import React from 'react'
import { httpError, getServerSideWrapper, verticalShowInfo, mapMediaDocToVideojsObject } from 'utils'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import InverseHeader from 'components/PartnershipsSite/InverseHeader'
import VerticalShow from 'components/PartnershipsSite/VerticalShow'
import VideoPlayerLite from 'components/VideoPlayerLite'
import { usePageView } from 'hooks'
import { MediaStore } from 'stores/media'

const VerticalSecondaryPage = ({ title, data, videoSource = {} }) => {
  usePageView()

  const showNames = data.map((show) => show.name).join(', ')

  return (
    <PartnershipsLayout
      title={`Barstool Sports Verticals - ${title} - Advertise with Barstool Sports`}
      description={`Advertise with ${title} shows via paid sponsorships & other partnership options. Shows include: ${showNames}.`}
    >
      <InverseHeader page={`VERTICALS // ${title}`} title={title} />
      {videoSource && (
        <div style={{ backgroundColor: '#f5f5f5', width: '100%', padding: '0.5rem' }}>
          <VideoPlayerLite videoSource={videoSource} />
        </div>
      )}
      {data.map((show, idx) => (
        <VerticalShow key={idx} {...show} />
      ))}
    </PartnershipsLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params }) => {
  const { title, data, videoID } =
    verticalShowInfo[params.slug.toLowerCase()] || httpError(404, 'Vertical does not exist')

  return {
    title,
    data,
    videoSource: videoID ? mapMediaDocToVideojsObject(await MediaStore().findById(videoID)) : false
  }
})

export default VerticalSecondaryPage
